export default "__VITE_ASSET__DyuHRUBV__"